<template>
  <transition name="scroll-y-transition">
    <div v-if="show" class="c-backdrop">
      <v-progress-circular color="accent" class="c-progress" indeterminate size="100" width="4"/>
    </div>
  </transition>
</template>

<script>
export default {
  data () {
    return {
      show: false,
      timeoutID: null
    };
  },
  computed: {
    visible () {
      return this.$store.state.cove.blocker.visible;
    },
    delay () {
      return this.$store.state.cove.blocker.delay;
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler (newValue) {
        if (newValue)
        {
          this.timeoutID = setTimeout(() => {
            this.show = true;
            window.addEventListener('keydown', preventKeyPress, true);
          }, this.delay);
        }
        else
        {
          this.show = false;
          clearTimeout(this.timeoutID);
          window.removeEventListener('keydown', preventKeyPress, true);
        }
      }
    }
  }
};

function preventKeyPress (e)
{
  e.preventDefault();
  return false;
}
</script>
